import {Field} from 'formik';

import {
    FormikNumberInput,
    FormikSelect,
    FormikTextInput,
    PlatformFieldset
} from '@flexinet/ui-components';
import {Stack} from "@mantine/core";
import {FormikList} from "../../../components/FormikList";
import {BillablePeriod} from "../types.ts";
import {BillableUnitsDropdown} from "../../billable-units/inputs/BillableUnitsDropdown.tsx";


export const FormComponent = () => {

    return (
        <Stack gap={'lg'}>
            <PlatformFieldset legend={'Rate Plan'}>
                <Field
                    name='name'
                    label='Name'
                    description='Please enter the ratePlans name'
                    component={FormikTextInput}
                    withAsterisk
                    my={'xl'}
                />

                {/* FNP-802: the billable unit is now a real record (meter + conversion
                    factor), selected from the Billable Units module — not a hardcoded
                    label list backed by nothing. The tier bands below are counted in
                    THIS unit, so it has to be a real reference. */}
                <Field
                    name='billableUnitId'
                    label='Billable Unit'
                    description='The unit this plan prices. Charge tiers below are counted in this unit.'
                    component={BillableUnitsDropdown}
                    withAsterisk
                    my={'xl'}
                />

                <Field
                    name='billablePeriod'
                    label='Billable Period'
                    description='Please enter the billable period'
                    component={FormikSelect}
                    data={[{
                        value: BillablePeriod.MONTH,
                        label: 'Month'
                    }, {
                        value: BillablePeriod.QUARTER,
                        label: 'Quarter'
                    }, {
                        value: BillablePeriod.YEAR,
                        label: 'Year'
                    }]}
                    withAsterisk
                    my={'xl'}
                />

            </PlatformFieldset>

            <PlatformFieldset legend={'Tiers'}>

                <Field
                    name='chargeTiers'
                    label='Charge Tiers'
                    // The rate is stored in MINOR UNITS (cents) — same as Price.amount and
                    // Stripe. Saying so here is the fix for a real money-entry trap: typing
                    // 0.50 meaning fifty cents was rejected with the opaque AppSync error
                    // "Variable 'rate' has an invalid value", and typing 50 meaning fifty
                    // DOLLARS would have silently charged 100x too little.
                    description='Rate is in CENTS per billable unit — enter 50 for $0.50, 1500 for $15.00. Whole numbers only.'
                    component={FormikList}
                    getRowElements={() => {
                        return [{
                            name: 'lowerBand',
                            placeholder: 'Lower Band',
                            component: FormikTextInput,
                        }, {
                            name: 'upperBand',
                            placeholder: 'Upper Band',
                            component: FormikTextInput,
                        }, {
                            name: 'rate',
                            placeholder: 'Rate (cents)',
                            component: FormikNumberInput,
                            // Reject a fractional cent at the FORM rather than letting it
                            // reach AppSync as an unreadable variable error.
                            allowDecimal: false,
                            min: 0,
                            step: 1,
                        }]
                    }}
                    my={'xl'}
                />

            </PlatformFieldset>

        </Stack>
    );
};
